import {
  ApplicationRoleSchema,
  RoleAnalysisStatusSchema,
} from '@terra/shared-schemas-orchestrator';
import { z } from 'zod';

export const ApplicationRoleBaseSchema = ApplicationRoleSchema;

const MAX_ROLE_NAME_LENGTH = 100;
const MAX_DESCRIPTION_LENGTH = 10000;

export const CreateApplicationRoleSchema = ApplicationRoleBaseSchema.omit({
  id: true,
  applicationId: true,
  tenantId: true,
  aiGeneratedDescription: true,
  analysisStatus: true,
  analysisJobId: true,
  analysisError: true,
  lastAnalyzedAt: true,
  createdAt: true,
  updatedAt: true,
}).extend({
  name: z
    .string()
    .min(1, 'Role name is required')
    .max(
      MAX_ROLE_NAME_LENGTH,
      `Role name must be at most ${MAX_ROLE_NAME_LENGTH} characters`,
    )
    .trim(),
  description: z
    .string()
    .max(
      MAX_DESCRIPTION_LENGTH,
      `Description must be at most ${MAX_DESCRIPTION_LENGTH} characters`,
    )
    .optional()
    .nullable(),
});

export const UpdateApplicationRoleSchema =
  CreateApplicationRoleSchema.partial().extend({
    name: z
      .string()
      .min(1, 'Role name is required')
      .max(
        MAX_ROLE_NAME_LENGTH,
        `Role name must be at most ${MAX_ROLE_NAME_LENGTH} characters`,
      )
      .trim()
      .optional(),
  });

export const ApplicationRoleResponseSchema = z.object({
  role: ApplicationRoleBaseSchema,
});

export const ApplicationRolesResponseSchema = z.object({
  roles: z.array(ApplicationRoleBaseSchema),
});

export const RoleAnalysisStatusResponseSchema = z.object({
  status: RoleAnalysisStatusSchema.nullable(),
  aiGeneratedDescription: z.string().nullable(),
  analysisError: z.string().nullable(),
  lastAnalyzedAt: z.date().nullable(),
});
